/*
 * @Descripttion:
 * @version:
 * @Author: geory
 * @Date: 2023-08-25 17:10:23
 * @LastEditors: geory
 * @LastEditTime: 2025-10-10 15:48:22
 */
import httpRequest from "./request";

const http = {
  //话术分类 排序(前200)
  sortHushuType(data) {
    return httpRequest.post(
      "group/web/shareSpeech/label/sort.do",
      data
    );
  },
  //查询话术详情
  fetchHuashuTeamDetail(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/v3/qryInfoBySpeechId.do",
      data
    );
  },
  //变量 查询列表
  fetchHuashuValList(data) {
    return httpRequest.post("/group/web/shareSpeech/field/queryList.do", data);
  },
  //话术文本 审核
  huashuReviewCheck(data) {
    return httpRequest.post("/group/web/shareSpeech/text/check/check.do", data);
  },
  //话术文本 待审核
  huashuReview(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/text/check/queryList.do",
      data
    );
  },
  //创建话术
  huashuTeamCreate(data) {
    return httpRequest.post("group/web/shareSpeech/v3/createSpeech.do", data);
  },
  //话术文本 批量操作
  huashuBatchOperate(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/text/batchOperate.do",
      data
    );
  },
  //话术文本 检查增量
  huashuCheckIncrement(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/text/checkIncrement.do",
      data
    );
  },
  //话术文本 查询增加
  huashuCheckIncrementAdd(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/text/queryIncrementAdd.do",
      data
    );
  },
  //话术文本 查询删除
  huashuCheckIncrementDel(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/text/queryIncrementDel.do",
      data
    );
  },
  //话术文本 移动分类
  moveHuashuType(data) {
    return httpRequest.post("/group/web/shareSpeech/text/updateLabel.do", data);
  },
  //话术分类 刷新
  huashuTypeRefreshTop(data) {
    return httpRequest.post("/group/web/shareSpeech/label/refresh.do", data);
  },
  //话术文本 刷新
  huashuRefreshTop(data) {
    return httpRequest.post("/group/web/shareSpeech/text/refresh.do", data);
  },
  //话术文本 更新置顶
  updateHuashuIsTop(data) {
    return httpRequest.post("/group/web/shareSpeech/text/updateIsTop.do", data);
  },
  //手机号码登录
  getLoginCode(data) {
    return httpRequest.post("/group/web/user/login.do", data, {
      isUnEncrypt: true,
    });
  },
  //发送验证码
  sendMegCode(data) {
    return httpRequest.post("/group/web/user/sendSms.do", data, {
      isUnEncrypt: true,
    });
  },
  //查询二维码
  createQrCode(data) {
    return httpRequest.post("/group/web/user/queryQrCode.do", data, {
      isUnEncrypt: true,
    });
  },
  //二维码登录
  loginByCode(data) {
    return httpRequest.post("/group/web/user/loginByQrCode.do", data, {
      isUnEncrypt: true,
    });
  },
  //查询话术列表
  qryHuashuTeamList(data) {
    return httpRequest.post("/group/web/shareSpeech/queryList.do", data);
  },
  //查询话术分类列表
  qryHuashuTypeList(data) {
    return httpRequest.post("/group/web/shareSpeech/label/queryList.do", data);
  },
  //查询话术文本列表
  qryHuashuList(data) {
    return httpRequest.post("/group/web/shareSpeech/text/queryList.do", data);
  },
  //话术分类 保存
  huashuTypeSave(data) {
    return httpRequest.post("/group/web/shareSpeech/label/save.do", data);
  },
  //话术分类 删除
  huashuTypeDel(data) {
    return httpRequest.post("/group/web/shareSpeech/label/del.do", data);
  },
  //话术文本 保存
  huashuSave(data) {
    return httpRequest.post("/group/web/shareSpeech/text/save.do", data);
  },
  //话术文本 删除
  huashuRemove(data) {
    return httpRequest.post("/group/web/shareSpeech/text/del.do", data);
  },
  //获取 上传token
  getFileUploadToken(data) {
    return httpRequest.post("/group/web/qiniu/getUpLoadKey.do", data, {
      isUnEncrypt: true,
    });
  },
  //话术多媒体 查询限制
  qryHuashuLimit(data) {
    return httpRequest.post("/group/web/shareSpeech/media/queryLimit.do", data);
  },
  //话术多媒体 提交映射
  submitHuashuMapping(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/media/submitMapping.do",
      data
    );
  },
  //话术多媒体 查询标题
  qryHuashuListTitle(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/media/queryFileTitle.do",
      data
    );
  },
  //话术多媒体 获取小程序码
  huashuGetMiniCode(data) {
    return httpRequest.post(
      "/group/web/shareSpeech/media/queryMiniProgramCode.do",
      data
    );
  },
  //话术文本 搜索
  huashuSearch(data) {
    return httpRequest.post("/group/web/shareSpeech/text/search.do", data);
  },
  //文案包 切换检查
  checkChangeWenanPackage(data) {
    return httpRequest.post(
      "/group/web/text/library/theme/checkTheme.do",
      data
    );
  },
  //文案包 我的列表
  wenanPackageList(data) {
    return httpRequest.post(
      "/group/web/text/library/theme/queryMyList.do",
      data
    );
  },
  //文案包分类 列表
  wenanCategoryList(data) {
    return httpRequest.post("/group/web/text/library/label/queryList.do", data);
  },
  //文案包文案 列表
  wenanList(data) {
    return httpRequest.post("/group/web/text/library/queryList.do", data);
  },
  //文案包 查询默认
  defaultWenanPackageList(data) {
    return httpRequest.post(
      "/group/web/text/library/theme/queryDefault.do",
      data
    );
  },
  //话术分类 批量保存
  huashuTypeBatSave(data) {
    return httpRequest.post("/group/web/shareSpeech/label/batchSave.do", data);
  },
  //话术文本 批量保存
  huashuBatSave(data) {
    return httpRequest.post("/group/web/shareSpeech/text/batchSave.do", data);
  },
};

export default http;
